<form [formGroup]="aiInsightSettingsForm" (ngSubmit)="onSubmitAiInsightSettings()">
  <div class="pt-2">
    <input type="checkbox" id="aiInsightsEnabled" formControlName="aiInsightsEnabled" />
    <label class="ps-1" for="aiInsightsEnabled">
      <h4>{{ 'Settings::AIInsights.Enabled' | abpLocalization }}</h4>
    </label>
  </div>
  <div *ngIf="aiInsightSettingsForm.get('aiInsightsEnabled').value">
    <div class="form-group pt-2 selector-class">
      <label for="insightTypes">
        {{ 'Settings::Insight' | abpLocalization }}
      </label>
      <ng-select
        formControlName="insightTypes"
        id="insightTypes"
        [items]="insightTypes"
        bindLabel="name"
        bindValue="code"
        [multiple]="true"
        [closeOnSelect]="false">
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
          <input
            id="item-{{ index }}"
            type="checkbox"
            [disabled]="isDisabled(item.code)"
            [ngModel]="item$.selected"
            [ngModelOptions]="{ standalone: true }" />
          {{ 'GenericLookup::' + item.code | abpLocalization }}
        </ng-template>
        <ng-template ng-label-tmp let-item="item">
          <span
            *ngIf="!isDisabled(item.code)"
            class="ng-value-icon left"
            aria-hidden="true"
            (click)="removeFromSelectedInsights(item.code)">
            ×
          </span>
          <span class="ng-value-label">
            {{ 'GenericLookup::' + item.code | abpLocalization }}
          </span>
        </ng-template>
      </ng-select>
      <small class="form-text text-muted">
        {{ 'Settings::InsightDescription' | abpLocalization }}
      </small>
    </div>
    <div class="form-group pt-2">
      <div class="form-group">
        <label for="languageCode">
          {{ 'Settings::InsightLanguageCode' | abpLocalization }}
        </label>
        <ca-select [class]="'below-all'" formControlName="languageCode" [(ngModel)]="languageCode">
          <ca-option *ngFor="let language of languagesDataSource" [value]="language.code">
            {{ 'Settings::Call.Language.' + language.name | abpLocalization }}
          </ca-option>
        </ca-select>
        @if (!whiteLabelingEnabled) {
          <small
            class="form-text text-muted"
            [innerHtml]="
              'Settings::Conversation:Language:CompleteListInfo' | abpLocalization
            "></small>
        }
      </div>
    </div>
    <div class="form-group pt-2">
      <input
        type="checkbox"
        id="customizeSummarizationEnabled"
        formControlName="customizeSummarizationEnabled" />
      <label for="customizeSummarizationEnabled" class="ps-1">
        {{ 'Settings::CustomizeSummarization' | abpLocalization }}
      </label>
    </div>
    <div
      class="form-group pt-2"
      *ngIf="aiInsightSettingsForm.get('customizeSummarizationEnabled')?.value">
      <input
        type="text"
        class="form-control form-control-sm"
        id="promptPrefix"
        formControlName="promptPrefix" />
      <small class="form-text text-muted">
        {{ 'Settings::CustomizeSummarizationInfo' | abpLocalization }}
      </small>
    </div>
    <div class="form-group pt-2">
      <div class="form-group">
        <label for="llmConfigurationId">
          {{ 'Settings::LLMConfiguration:LLMConfiguration' | abpLocalization }}
        </label>
        <ca-select [clearable]="true" [class]="'below-all'" formControlName="llmConfigurationId">
          <ca-option
            *ngFor="let llmConfiguration of llmConfigurations"
            [value]="llmConfiguration.id">
            {{ llmConfiguration.name }}
          </ca-option>
        </ca-select>
      </div>
    </div>
    <ng-template #customizeSummarizationServiceInfoContent>
      <div class="text-start" [innerHTML]="customizeSummarizationServiceInfo"></div>
    </ng-template>
    <div class="form-group pt-2">
      <ca-automatic-summarization-settings
        [maxDailyConversationLimit]="aiInsightsDailyLimit"></ca-automatic-summarization-settings>
    </div>
  </div>
  <!-- end *ngIf aiInsightsEnabled -->
  <div>
    <button type="button" type="submit" class="btn btn-primary mt-3">
      <i class="me-1 fas fa-save"></i>
      {{ 'AbpUi::Save' | abpLocalization }}
    </button>
  </div>
</form>
